import { useMemo, useState } from "react";
import { Box, Button, Form } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import styles from "../../../components/Overrides.module.css";
import { SerializedBoardData, createBoard, editBoard } from "../../../models/board";
import { useAuthContext } from "../../auth/AuthProvider";
import { ModalProps } from "../ModalManager";

export type CreateOrEditBoardModalProps = {
  boardData?: SerializedBoardData
} & ModalProps;

export function CreateOrEditBoardModal({ ...props }: CreateOrEditBoardModalProps) {
  const { t } = useTranslation();
  const [userUid] = useAuthContext();
  const [title, setTitle] = useState(props.boardData ? props.boardData.title : "");
  const [description, setDescription] = useState(props.boardData?.description ? props.boardData.description : "");

  const onClickConfirm = async () => {
    if (userUid === null) return;
    if (props.boardData) {
      editBoard(props.boardData, title, description || null, false)
    } else {
      createBoard(userUid, title, description || null, false)
    };
    props.closeModal();
  }

  const isConfirmDisabled = useMemo(() => {
    return !title || title.length < 1
  }, [title])

  return (
    <Box>
      <p className="title">{props.boardData ? t("edit-board.title") : t("create-board.title")}</p>
      <form>
        <Form.Field>
          <Form.Label>{t("title")}</Form.Label>
          <Form.Control>
            <Form.Input
              type="text"
              autoFocus={true}
              placeholder={t("create-board.title-placeholder")}
              value={title}
              onChange={(e) => setTitle(e.target.value)} />
          </Form.Control>
        </Form.Field>
        <Form.Field>
          <Form.Label>{t("description")}</Form.Label>
          <Form.Control>
            <Form.Textarea className={styles.textarea}
              placeholder={t("create-board.description-placeholder")}
              value={description}
              onChange={(e) => setDescription(e.target.value)} />
          </Form.Control>
        </Form.Field>

        <Form.Field className="is-grouped">
          <Form.Control>
            <Button color="info" onClick={onClickConfirm} disabled={isConfirmDisabled}>
              {props.boardData ? t("save") : t("create")}
            </Button>
          </Form.Control>
          <Form.Control>
            <Button className="is-ghost has-text-info" onClick={props.closeModal}>
              {t("cancel")}
            </Button>
          </Form.Control>
        </Form.Field>
      </form>
    </Box>
  )
}
